import PropTypes from "prop-types";
import { CustomPagination, PageSizeWrapper, PaginationTextWrapper } from "./PaginationStyled";
import PreviousIcon from "../../assets/images/previous.svg";
import NextIcon from "../../assets/images/next.svg";
import Dropdown from "../Dropdown/Dropdown";
import { PAGE_SIZE_OPTIONS } from "../../utils/constants";
import { customItemRender } from "./PaginationUtils";

const Pagination = ({
  current = 1,
  total = 40,
  pageSize = 10,
  onChange,
  searchQuery = "",
  adjustable = false,
  onPageSizeChange,
}) => {
  const isSearchActive = searchQuery.trim().length > 0;

  let startEntry;
  if (isSearchActive) {
    startEntry = total > 0 ? 1 : 0;
  } else {
    startEntry = (current - 1) * pageSize + 1;
  }

  const endEntry = isSearchActive ? total : Math.min(current * pageSize, total);
  const itemCount = endEntry - startEntry + 1;

  return (
    <PaginationTextWrapper>
      <span className="pagination-text">
        {adjustable ? (
          <PageSizeWrapper>
            Displaying
            <Dropdown
              allowborder
              pagination
              value={String(pageSize)}
              handleChange={onPageSizeChange}
              options={PAGE_SIZE_OPTIONS}
            />
            items
          </PageSizeWrapper>
        ) : (
          `Displaying ${itemCount} items`
        )}
      </span>

      <CustomPagination
        current={current}
        total={total}
        pageSize={pageSize}
        onChange={onChange}
        showSizeChanger={false}
        itemRender={(page, type, originalElement) => customItemRender(page, type, originalElement, PreviousIcon, NextIcon)}
      />
    </PaginationTextWrapper>
  );
};

Pagination.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number,
  pageSize: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  searchQuery: PropTypes.string,
  adjustable: PropTypes.bool,
  onPageSizeChange: PropTypes.func,
};

export default Pagination;
